import React from 'react';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/react';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';
import { ChevronDownIcon } from '@heroicons/react/20/solid';

interface IProps {
    templates: string[];
    onTemplateDownload: (templatePath: string) => void;
}

export function TemplatesDropdown(props: IProps) {
    const { templates, onTemplateDownload } = props;
    return (
        <Menu as='div' className='relative'>
            <MenuButton className='w-full rounded bg-white py-1 text-sm text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-200 flex justify-center disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'>
                <DocumentDuplicateIcon className='h-4 w-4 my-auto mr-1' aria-hidden='true' />
                Templates
                <ChevronDownIcon aria-hidden='true' className='-mr-1 size-5 text-gray-900' />
            </MenuButton>
            <MenuItems
                portal={false}
                transition
                className='absolute right-0 z-10 mt-2 w-fit origin-top-right border border-gray-200 rounded-md bg-white shadow-lg outline outline-1 outline-black/5 transition data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10'
            >
                <div className='py-1'>
                    {templates.map((template, index) => {
                        const fileName = template.replace('assets://', '').split('/').pop() || `Template ${index + 1}`;
                        return (
                            <MenuItem key={index}>
                                <button
                                    type='button'
                                    onClick={() => onTemplateDownload(template)}
                                    className='block w-full px-4 py-2 text-right text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none dark:text-gray-300 dark:data-[focus]:bg-white/5 dark:data-[focus]:text-white'
                                >
                                    {fileName}
                                </button>
                            </MenuItem>
                        );
                    })}
                </div>
            </MenuItems>
        </Menu>
    );
}
